/*** IMPORTS FROM imports-loader ***/
var videojs = require("video.js");

videojs.addLanguage("ru",{
 "Play": "Воспроизвести",
 "Pause": "Приостановить",
 "Current Time": "Текущее время",
 "Duration Time": "Продолжительность",
 "Remaining Time": "Оставшееся время",
 "Stream Type": "Тип потока",
 "LIVE": "ОНЛАЙН",
 "Loaded": "Загрузка",
 "Progress": "Прогресс",
 "Fullscreen": "Полноэкранный режим",
 "Non-Fullscreen": "Неполноэкранный режим",
 "Mute": "Без звука",
 "Unmute": "Со звуком",
 "Playback Rate": "Скорость воспроизведения",
 "Subtitles": "Субтитры",
 "subtitles off": "Субтитры выкл.",
 "Captions": "Подписи",
 "captions off": "Подписи выкл.",
 "Chapters": "Главы",
 "Close Modal Dialog": "Закрыть модальное окно",
 "Descriptions": "Описания",
 "descriptions off": "описания выкл.",
 "Audio Track": "Звуковая дорожка",
 "You aborted the media playback": "Вы прервали воспроизведение видео",
 "A network error caused the media download to fail part-way.": "Ошибка сети вызвала сбой во время загрузки видео.",
 "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Невозможно загрузить видео из-за сетевого или серверного сбоя либо формат не поддерживается.",
 "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Воспроизведение видео было приостановлено из-за повреждения либо в связи с тем, что видео использует функции, неподдерживаемые вашим браузером.",
 "No compatible source was found for this media.": "Совместимые источники для этого видео отсутствуют.",
 "The media is encrypted and we do not have the keys to decrypt it.": "Видео в зашифрованном виде, и у нас нет ключей для расшифровки.",
 "Play Video": "Воспроизвести видео",
 "Close": "Закрыть",
 "Modal Window": "Модальное окно",
 "This is a modal window": "Это модальное окно.",
 "This modal can be closed by pressing the Escape key or activating the close button.": "Модальное окно можно закрыть нажав Esc или кнопку закрытия окна.",
 ", opens captions settings dialog": ", откроется диалог настройки подписей",
 ", opens subtitles settings dialog": ", откроется диалог настройки субтитров",
 ", opens descriptions settings dialog": ", откроется диалог настройки описаний",
 ", selected": ", выбрано"
});



//////////////////
// WEBPACK FOOTER
// ./~/imports-loader?videojs=video.js!./~/video.js/dist/lang/ru.js
// module id = 74
// module chunks = 0